module.exports = __webpack_public_path__ + "img/c3.e6258cd0.png";